if (document.getElementById('count-down-timer')) {

    window.addEventListener('load', () => {
        let countTimer = document.getElementById('count-down-timer');
        let count = 30;
        setInterval(() => {
            if (count > 0) {
                count--
                countTimer.innerHTML = count;
            } else {
                location.reload();
            }
        }, 1000);

        let reloadPageButton = document.getElementById('reloadPageButton');

        reloadPageButton.addEventListener('click', () => {
            location.reload();
        })
    })
}
